import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { CircularProgress } from '../../components/CircularProgress';
import { StockNotFound } from '../../components/StockNotFound';

import { StockTable } from './StockTable';

import { useStocks } from './useStocks';

import { stockPath } from '../../utils/path';

export const StocksPage: React.FC = () => {
  const [params] = useSearchParams();
  const query = params.get('query');
  const stocks = useStocks(query);
  const navigate = useNavigate();

  useEffect(() => {
    if (stocks && stocks.length === 1) {
      navigate(stockPath(stocks[0].code), { state: { stock: stocks[0] } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stocks]);

  return stocks ? (
    stocks.length === 0 ? (
      <StockNotFound code={query} />
    ) : (
      <div className="mt-8 flex justify-center">
        <StockTable stocks={stocks} />
      </div>
    )
  ) : (
    <CircularProgress className="mt-8" />
  );
};
